import React, { Component } from "react";
import Navbar from "../../components/newNavBar";
import Loader from "../../utils/loader";
import less from "./payouts.module.scss";
import AadharOtpModal from "../../components/AadharOtpModal";
import { message, Modal } from "antd";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { Fetch } from "../../utils/fetch";
import jwt from "../../utils/jwt";
import moment from "moment";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../config";

class kyc extends Component {
  state = {
    loading: true,
    gst: "",
    pan: "",
    msme: "",
    aadhar: "",
    showAadharModal: false,
    showVerificationSuccessModal: false,
    showNameMismatchModal: false,
    showVerificationFailedModal: false,
  };

  async componentDidMount() {
    try {
      const stateObj = { loading: false };
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      const userMobileNo = decodedToken.mobileNo;
      const userName = decodedToken.name;
      await this.fetchProfileDetails(userMobileNo);
      stateObj.userMobileNo = userMobileNo;
      stateObj.userName = userName;

      stateObj.loading = false;
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      this.setState(stateObj);
    } catch (err) {
      console.log(err);
    }
  }

  fetchProfileDetails = async (userMobileNo) => {
    const url = `/user/details?mobileNo=${userMobileNo}`;
    const options = {
      method: "get",
    };
    const stateObj = { loading: false };

    const response = await Fetch(url, options);
    if (response) {
      const userDetails = response[0];
      const subType = userDetails.subType;
      const kycDetails = userDetails.kycDetails || {};
      if (subType) {
        if (subType === "INDIVIDUAL") {
          stateObj.subType = "INDIVIDUAL";
          if (kycDetails) {
            stateObj.aadhar = kycDetails.individualAadhaar || "";
            stateObj.msme = kycDetails.individualMsme || "";
            stateObj.pan = kycDetails.individualPan || "";
            stateObj.gst = kycDetails.individualGstin || "";
          }
        } else if (subType === "COMPANY") {
          stateObj.subType = "COMPANY";
          if (kycDetails) {
            stateObj.gst = kycDetails.companyGstin || "";
            stateObj.msme = kycDetails.companyMsme || "";
            stateObj.pan = kycDetails.companyPan || "";
          }
        } else if (subType === "PROPRIETORSHIP") {
          stateObj.subType = "PROPRIETORSHIP";
          if (kycDetails) {
            stateObj.msme = kycDetails.proprietorshipMsme || "";
            stateObj.pan = kycDetails.proprietorshipPan || "";
            stateObj.gst = kycDetails.proprietorshipGstin || "";
          }
        } else if (subType === "LLP") {
          stateObj.subType = "LLP";
          if (kycDetails) {
            stateObj.msme = kycDetails.llpMsme || "";
            stateObj.gst = kycDetails.llpGstin || "";
            stateObj.pan = kycDetails.llpPan || "";
          }
        } else {
          stateObj.subType = "PARTNERSHIP";
          if (kycDetails) {
            stateObj.gst = kycDetails.partnershipGstin || "";
            stateObj.msme = kycDetails.partnershipMsme || "";
            stateObj.pan = kycDetails.partnershipPan || "";
          }
        }
      }
      stateObj.isGSTINRequired = userDetails.isGSTINRequired;
      stateObj.isMSME = userDetails.isMSME;

      this.setState(stateObj);
      return;
    } else {
      message.error("no data found");
      return;
    }
  };

  handleChange = (field, value) => {
    this.setState((prevState) => {
      const errors = { ...prevState.errors };
      errors[field] = "";

      return {
        [field]: value,
        errors,
      };
    });
  };

  showAadharVerify = async () => {
    const { aadhar } = this.state;
    if (aadhar.length !== 12) {
      alert("Please enter a valid Aadhar number");
      return;
    } else {
      const options = {
        method: "post",
        data: { aadhaarNumber: aadhar },
      };
      const url = "/user/aadharOtp";

      const response = await Fetch(url, options);
      if (
        response.decentroError &&
        response.decentroResponseKey === "error_provider_error"
      ) {
        message.error(
          "No response received from the underlying provider. Please try again after sometime. If the problem persists, please drop a mail to support@decentro.tech"
        );
        return;
      }
      this.setState({
        showAadharModal: true,
        transactionId: response.decentroTxnId,
      });
    }
  };

  verifyAadhar = async (otp) => {
    const { aadhar, transactionId, userMobileNo, userName } = this.state;
    if (otp.length !== 6) {
      alert("Please enter a valid OTP");
      return;
    }
    const options = {
      method: "post",
      data: { aadhaarNumber: aadhar, transactionId, otp },
    };
    const url = "/user/aadharVerify";

    const response = await Fetch(url, options);
    if (response.verified) {
      this.setState({
        showAadharModal: false,
        showVerificationSuccessModal: true,
        kycOf: "AADHAR",
        aadhar: {
          token: aadhar,
          verifiedOn: new Date(),
        },
      });
    } else if (response.statusCode === "nameMismatch") {
      this.setState({
        showAadharModal: false,
        showNameMismatchModal: true,
      });

      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("KYC Name Mismatch", {
        document_type: "AADHAR",
        name_api_response: response.documentName,
        name_system: userName,
        registered_number: userMobileNo,
      });
    } else {
      this.setState({
        showAadharModal: false,
        errorMessage:
          response.message === "Transaction ID is required"
            ? "Wrong OTP. Please try again."
            : response.message,
        showVerificationFailedModal: true,
      });
    }
  };

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  verifyGST = async () => {
    this.setState({ verificationGSTLoader: true });
    const { gst, userMobileNo, userName } = this.state;
    if (!gst || typeof gst === "object") {
      message.error("Please enter GST to verify");
      this.setState({
        verificationGSTLoader: false,
      });
      return;
    }

    const payload = { gst };
    const options = { method: "post", data: payload };
    const url = "/user/kycVerify";
    const response = await Fetch(url, options);

    if (response.decentroResponseKey === "NAME_MISMATCHED") {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("KYC Name Mismatch", {
        document_type: "GST",
        name_api_response: response.documentName,
        name_system: userName,
        registered_number: userMobileNo,
      });
      this.setState({ showNameMismatchModal: true });
    } else if (!response.verified) {
      this.setState({
        showVerificationFailedModal: true,
        errorMessage: response.message,
        verificationGSTLoader: false,
      });
    } else {
      this.setState({
        gst: { number: gst, verifiedOn: new Date() },
        showVerificationSuccessModal: true,
        kycOf: "GSTIN",
        verificationGSTLoader: false,
      });
    }
  };

  verifyPAN = async () => {
    this.setState({ verificationPANLoader: true });
    const { pan, userMobileNo, userName } = this.state;
    if (!pan || typeof pan === "object") {
      message.error("Please enter PAN to verify");
      this.setState({
        verificationPANLoader: false,
      });
      return;
    }

    const payload = { pan };
    const options = { method: "post", data: payload };
    const url = "/user/kycVerify";
    const response = await Fetch(url, options);

    if (response.decentroResponseKey === "NAME_MISMATCHED") {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("KYC Name Mismatch", {
        document_type: "PAN",
        name_api_response: response.documentName,
        name_system: userName,
        registered_number: userMobileNo,
      });
      this.setState({ showNameMismatchModal: true });
    } else if (!response.verified) {
      this.setState({
        showVerificationFailedModal: true,
        errorMessage: response.message,
        verificationPANLoader: false,
      });
    } else {
      this.setState({
        pan: { token: pan, verifiedOn: new Date() },
        showVerificationSuccessModal: true,
        kycOf: "PAN",
        verificationPANLoader: false,
      });
    }
  };

  verifyMSME = async () => {
    this.setState({ verificationLoader: true });
    const { msme, userMobileNo, userName } = this.state;
    if (!msme || typeof msme === "object") {
      message.error("Please enter MSME to verify");
      this.setState({
        verificationLoader: false,
      });
      return;
    }

    const payload = { msme };
    const options = { method: "post", data: payload };
    const url = "/user/kycVerify";
    const response = await Fetch(url, options);

    if (response.decentroResponseKey === "NAME_MISMATCHED") {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("KYC Name Mismatch", {
        document_type: "MSME",
        name_api_response: response.documentName,
        name_system: userName,
        registered_number: userMobileNo,
      });
      this.setState({ showNameMismatchModal: true });
    } else if (!response.verified) {
      this.setState({
        showVerificationFailedModal: true,
        errorMessage: response.message,
        verificationLoader: false,
      });
    } else {
      this.setState({
        msme: { number: msme, verifiedOn: new Date() },
        showVerificationSuccessModal: true,
        verificationLoader: false,
        kycOf: "MSME",
      });
    }
  };

  render() {
    const {
      loading,
      subType,
      isMobile,
      gst,
      pan,
      msme,
      aadhar,
      showAadharModal,
      showVerificationFailedModal,
      showVerificationSuccessModal,
      showNameMismatchModal,
      showSideMenu,
      isGSTINRequired = false,
      kycOf = "",
      errorMessage = "Invalid Document. Please use a different one or contact support.",
      isMSME = false,
      verificationLoader = false,
      verificationPANLoader = false,
      verificationGSTLoader = false,
    } = this.state;
    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <div>
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={6}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          <div class="container">
            <div className={less.header}>
              <span>KYC Verification</span>
              <span>
                Complete the KYC verification to continue using the account.
              </span>
            </div>
            <div className={less.gridContainer}>
              <div className={less.verification}>
                <div className={less.heading}>
                  <span>PAN</span>
                  {pan.token ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Enter PAN number here"
                  className={less.input}
                  value={pan.token ? "**********" : pan}
                  disabled={pan.token}
                  onChange={(e) =>
                    this.handleChange("pan", e.target.value.toUpperCase())
                  }
                />
                {pan && pan.token ? (
                  <span className={less.verificationNote}>
                    PAN verification was successfully completed on{" "}
                    {moment(pan.verifiedOn).format("LLL")}
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.verifyPAN}>
                      {verificationPANLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify PAN"
                      )}
                    </button>
                  </div>
                )}
              </div>

              {subType === "INDIVIDUAL" ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>AADHAR</span>
                    {aadhar.token ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter AADHAR number here"
                    className={less.input}
                    value={aadhar.token ? "**** **** ****" : aadhar}
                    disabled={aadhar.token}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/\D/g, ""); // remove everything except digits
                      this.handleChange("aadhar", onlyNums);
                    }}
                  />
                  {aadhar && aadhar.token ? (
                    <span className={less.verificationNote}>
                      AADHAR verification was successfully completed on{" "}
                      {moment(aadhar.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button
                        className={less.verify}
                        onClick={this.showAadharVerify}
                      >
                        Send OTP
                      </button>
                    </div>
                  )}
                </div>
              ) : null}
              {isGSTINRequired ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>GSTIN</span>
                    {gst.number ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter GSTIN number here"
                    className={less.input}
                    value={gst.number ? gst.number : gst}
                    disabled={gst.number}
                    onChange={(e) =>
                      this.handleChange("gst", e.target.value.toUpperCase())
                    }
                  />
                  {gst && gst.number ? (
                    <span className={less.verificationNote}>
                      GSTIN verification was successfully completed on{" "}
                      {moment(gst.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button className={less.verify} onClick={this.verifyGST}>
                        {verificationGSTLoader ? (
                          <span className={less.loader}></span>
                        ) : (
                          "Verify GSTIN"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ) : null}

              <div className={less.verification}>
                <div className={less.heading}>
                  <span>MSME</span>
                  {msme && msme.number ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : isMSME ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />
                      <span>PENDING</span>
                    </div>
                  ) : (
                    <div>
                      <span>You were registered as a non MSME entity</span>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Enter MSME number here"
                  className={less.input}
                  value={msme.number ? msme.number : msme}
                  disabled={!isMSME || msme.number}
                  onChange={(e) =>
                    this.handleChange("msme", e.target.value.toUpperCase())
                  }
                />
                {msme.number ? (
                  <span className={less.verificationNote}>
                    MSME verification was successfully completed on{" "}
                    {moment(msme.verifiedOn).format("LLL")}
                  </span>
                ) : isMSME ? (
                  <div className={less.buttonContainer}>
                    <button
                      className={less.verify}
                      disabled={!isMSME || msme.number}
                      onClick={this.verifyMSME}
                    >
                      {verificationLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify MSME"
                      )}
                    </button>
                  </div>
                ) : (
                  <div className={less.buttonContainer}>
                    <button
                      disabled={!isMSME || msme.number}
                      onClick={this.verifyMSME}
                      style={{
                        backgroundColor: "#C2C2C2",
                        cursor: "not-allowed",
                      }}
                    >
                      Verify MSME
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className={less.operatorType}>
              <span>Operator Type</span>
              <span className={less.note}>
                <b>Note:</b> Your operator type has been registered as "COMPANY"
                in our systems. Please reach out to out team to change this.
              </span>
              <div className={less.types}>
                {[
                  {
                    label: "INDIVIDUAL",
                    description:
                      "Individual operators needs to provide PAN and Aadhar mandatorily. GSTIN is an optional requirement.",
                  },
                  {
                    label: "COMPANY",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                  {
                    label: "PROPRIETORSHIP",
                    description:
                      "PAN is mandatory for proprietors. GSTIN in needed when turnover exceed ₹20L.",
                  },
                  {
                    label: "LLP",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                  {
                    label: "PARTNERSHIP",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                ]
                  .sort((a, b) =>
                    a.label === subType ? -1 : b.label === subType ? 1 : 0
                  )
                  .map(({ label, description }) => (
                    <div
                      key={label}
                      className={
                        subType === label ? less.selected : less.unselected
                      }
                    >
                      <div>
                        <span>{label}</span>
                        {subType === label ? (
                          <img src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/accept.svg" />
                        ) : null}
                      </div>
                      <span>{description}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <AadharOtpModal
            visible={showAadharModal}
            onCancel={() => {
              this.setState({ showAadharModal: false });
            }}
            invalid={false}
            onVerify={(otp) => this.verifyAadhar(otp)}
          />
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            onCancel={() => {
              this.setState({ showVerificationFailedModal: false });
            }}
            open={showVerificationFailedModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Verification Failed</p>
              <span>{errorMessage}</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationFailedModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            open={showVerificationSuccessModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/done.svg"
                alt="close"
              />
              <p>Verification Successful</p>
              <span>Your {kycOf} has been successfully verified</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationSuccessModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            open={showNameMismatchModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Name Mismatch</p>
              <span>
                The name on your document doesn't match your account name.
                Please verify and re-enter.
              </span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showNameMismatchModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={6.2} isMobile={isMobile} />
          <div class="container">
            <div className={less.header}>
              <span>KYC Verification</span>
              <span>
                Complete the KYC verification to continue using the account.
              </span>
            </div>
            <div className={less.gridContainer}>
              <div className={less.verification}>
                <div className={less.heading}>
                  <span>PAN</span>
                  {pan.token ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />

                      <span>PENDING</span>
                    </div>
                  )}
                </div>
                <input
                  uppr
                  type="text"
                  placeholder="Enter PAN number here"
                  className={less.input}
                  value={pan.token ? "**********" : pan}
                  disabled={pan.token}
                  onChange={(e) =>
                    this.handleChange("pan", e.target.value.toUpperCase())
                  }
                />
                {pan && pan.token ? (
                  <span className={less.verificationNote}>
                    PAN verification was successfully completed on{" "}
                    {moment(pan.verifiedOn).format("LLL")}
                  </span>
                ) : (
                  <div className={less.buttonContainer}>
                    <button className={less.verify} onClick={this.verifyPAN}>
                      {verificationPANLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify PAN"
                      )}
                    </button>
                  </div>
                )}
              </div>
              {subType === "INDIVIDUAL" ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>AADHAR</span>
                    {aadhar.token ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter AADHAR number here"
                    className={less.input}
                    value={aadhar.token ? "**** **** ****" : aadhar}
                    disabled={aadhar.token}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/\D/g, ""); // remove everything except digits
                      this.handleChange("aadhar", onlyNums);
                    }}
                  />
                  {aadhar && aadhar.token ? (
                    <span className={less.verificationNote}>
                      AADHAR verification was successfully completed on{" "}
                      {moment(aadhar.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button
                        className={less.verify}
                        onClick={this.showAadharVerify}
                      >
                        Send OTP
                      </button>
                    </div>
                  )}
                </div>
              ) : null}

              {isGSTINRequired ? (
                <div className={less.verification}>
                  <div className={less.heading}>
                    <span>GSTIN</span>
                    {gst.number ? (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="VERIFIED"
                        />

                        <span>Verified</span>
                      </div>
                    ) : (
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                          alt="exclamation mark"
                        />
                        <span>PENDING</span>
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    placeholder="Enter GSTIN number here"
                    className={less.input}
                    value={gst.number ? gst.number : gst}
                    disabled={gst.number}
                    onChange={(e) =>
                      this.handleChange("gst", e.target.value.toUpperCase())
                    }
                  />
                  {gst && gst.number ? (
                    <span className={less.verificationNote}>
                      GSTIN verification was successfully completed on{" "}
                      {moment(gst.verifiedOn).format("LLL")}
                    </span>
                  ) : (
                    <div className={less.buttonContainer}>
                      <button className={less.verify} onClick={this.verifyGST}>
                        {verificationGSTLoader ? (
                          <span className={less.loader}></span>
                        ) : (
                          "Verify GSTIN"
                        )}
                      </button>
                    </div>
                  )}
                </div>
              ) : null}

              <div className={less.verification}>
                <div className={less.heading}>
                  <span>MSME</span>
                  {msme && msme.number ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                        alt="VERIFIED"
                      />

                      <span>Verified</span>
                    </div>
                  ) : isMSME ? (
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/exclamation.svg"
                        alt="exclamation mark"
                      />
                      <span>PENDING</span>
                    </div>
                  ) : (
                    <div>
                      <span>You were registered as a non MSME entity</span>
                    </div>
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Enter MSME number here"
                  className={less.input}
                  value={msme.number ? msme.number : msme}
                  disabled={msme.number || !isMSME}
                  onChange={(e) =>
                    this.handleChange("msme", e.target.value.toUpperCase())
                  }
                />
                {msme.number ? (
                  <span className={less.verificationNote}>
                    MSME verification was successfully completed on{" "}
                    {moment(msme.verifiedOn).format("LLL")}
                  </span>
                ) : isMSME ? (
                  <div className={less.buttonContainer}>
                    <button
                      className={less.verify}
                      disabled={!isMSME || msme.number}
                      onClick={this.verifyMSME}
                    >
                      {verificationLoader ? (
                        <span className={less.loader}></span>
                      ) : (
                        "Verify MSME"
                      )}
                    </button>
                  </div>
                ) : (
                  <div className={less.buttonContainer}>
                    <button
                      disabled={!isMSME || msme.number}
                      onClick={this.verifyMSME}
                      style={{
                        backgroundColor: "#C2C2C2",
                        cursor: "not-allowed",
                      }}
                    >
                      Verify MSME
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className={less.operatorType}>
              <span>Operator Type</span>
              <span className={less.note}>
                <b>Note:</b> Your operator type has been registered as "
                {subType}" in our systems. Please reach out to out team to
                change this.
              </span>
              <div className={less.types}>
                {[
                  {
                    label: "INDIVIDUAL",
                    description:
                      "Individual operators needs to provide PAN and Aadhar mandatorily. GSTIN is an optional requirement.",
                  },
                  {
                    label: "COMPANY",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                  {
                    label: "PROPRIETORSHIP",
                    description:
                      "PAN is mandatory for proprietors. GSTIN in needed when turnover exceed ₹20L.",
                  },
                  {
                    label: "LLP",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                  {
                    label: "PARTNERSHIP",
                    description:
                      "Registered operators must provide PAN and GSTIN for the legal identification.",
                  },
                ]
                  .sort((a, b) =>
                    a.label === subType ? -1 : b.label === subType ? 1 : 0
                  )
                  .map(({ label, description }) => (
                    <div
                      key={label}
                      className={
                        subType === label ? less.selected : less.unselected
                      }
                    >
                      <div>
                        <span>{label}</span>
                        {subType === label ? (
                          <img src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/accept.svg" />
                        ) : null}
                      </div>
                      <span>{description}</span>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <AadharOtpModal
            visible={showAadharModal}
            onCancel={() => {
              this.setState({ showAadharModal: false });
            }}
            invalid={false}
            onVerify={(otp) => this.verifyAadhar(otp)}
          />
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            onCancel={() => {
              this.setState({ showVerificationFailedModal: false });
            }}
            open={showVerificationFailedModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Verification Failed</p>
              <span>{errorMessage}</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationFailedModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            open={showVerificationSuccessModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/done.svg"
                alt="close"
              />
              <p>Verification Successful</p>
              <span>Your {kycOf} has been successfully verified</span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showVerificationSuccessModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
          <Modal
            centered
            closable={null}
            footer={null}
            title={null}
            open={showNameMismatchModal}
          >
            <div className={less.modalContent}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/kyc/crisis.svg"
                alt="close"
              />
              <p>Name Mismatch</p>
              <span>
                The name on your document doesn't match your account name.
                Please verify and re-enter.
              </span>
              <button
                className={less.modalButton}
                onClick={() =>
                  this.setState({
                    showNameMismatchModal: false,
                    verificationLoader: false,
                    verificationPANLoader: false,
                    verificationGSTLoader: false,
                  })
                }
              >
                Ok
              </button>
            </div>
          </Modal>
        </div>
      );
    }
  }
}

export default kyc;
